export const AVAILABLE_LANGUAGES = [
  { code: 'en', nameKey: 'languages.en' },
  { code: 'de', nameKey: 'languages.de' },
  { code: 'fr', nameKey: 'languages.fr' },
  { code: 'es', nameKey: 'languages.es' },
  { code: 'it', nameKey: 'languages.it' },
  { code: 'pt', nameKey: 'languages.pt' },
  { code: 'ja', nameKey: 'languages.ja' },
  { code: 'zh', nameKey: 'languages.zh' },
];

// Subset used in the header / top-level language switcher
export const UI_LANGUAGES = ['en', 'de'];
